/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { Link, useTranslations } from "@i18n/next";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { URL_ONBOARDING } from "@packages/sdk";
import { Button, useDynamicViewport } from "@packages/ui";
import { useEffect, useState } from "react";

import { LINKS } from "../../constants";
import { useABLoadingWithTimeout } from "../../hooks/useABLoadingWithTimeout";

type TryHallowForFreeProps = {
  buttonCss?: Interpolation | null;
};

const disabledOverride: Interpolation = {
  opacity: 1,
};

const Internal = ({ buttonCss }: TryHallowForFreeProps) => {
  // note the different min-width, copied from MenuBar.tsx
  const isDesktop = useDynamicViewport({ minimumWidth: 1024 });
  const analytics = useAnalytics();
  const t = useTranslations();

  const [isClient, setIsClient] = useState<boolean>(false);

  useEffect(() => {
    setIsClient(typeof window !== "undefined");
  }, []);

  if (!isClient)
    return (
      <Button css={[disabledOverride, buttonCss]} disabled>
        {t(LINKS.tryHallowForFree.message)}
      </Button>
    );

  return (
    <Button
      asChild
      onClickCapture={() =>
        analytics.track({
          event: HallowAnalyticsEvent.TappedTryHallowForFree,
          properties: {
            button_location: "menu_bar",
          },
        })
      }
      css={buttonCss}
      size={isDesktop ? "m" : "l"}
      isFullWidth={!isDesktop}
    >
      <Link {...LINKS.tryHallowForFree.props} href={URL_ONBOARDING}>
        {t(LINKS.tryHallowForFree.message)}
      </Link>
    </Button>
  );
};

export const TryHallowForFree = ({ buttonCss }: TryHallowForFreeProps) => {
  const { isLoading } = useABLoadingWithTimeout();
  const t = useTranslations();
  if (isLoading)
    return (
      <Button css={[disabledOverride, buttonCss]} disabled>
        {t(LINKS.tryHallowForFree.message)}
      </Button>
    );
  return <Internal buttonCss={buttonCss} />;
};
